var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { useFloating, useDismiss, useRole, useInteractions, FloatingFocusManager, offset, flip, shift, useHover, autoUpdate, useFocus, FloatingPortal, } from "@floating-ui/react";
var Tooltip = function (_a) {
    var content = _a.content, _b = _a.disabled, disabled = _b === void 0 ? false : _b, children = _a.children, _c = _a.placement, placement = _c === void 0 ? "bottom-end" : _c, _d = _a.bottomGap, bottomGap = _d === void 0 ? 8 : _d, controlledOpen = _a.open, setControlledOpen = _a.onOpenChange, props = __rest(_a, ["content", "disabled", "children", "placement", "bottomGap", "open", "onOpenChange"]);
    var _e = React.useState(false), uncontrolledOpen = _e[0], setUncontrolledOpen = _e[1];
    var open = controlledOpen !== null && controlledOpen !== void 0 ? controlledOpen : uncontrolledOpen;
    var setOpen = setControlledOpen !== null && setControlledOpen !== void 0 ? setControlledOpen : setUncontrolledOpen;
    var _f = useFloating({
        placement: placement,
        open: open,
        onOpenChange: setOpen,
        whileElementsMounted: autoUpdate,
        middleware: [
            offset(bottomGap),
            flip({
                crossAxis: placement.includes("-"),
                fallbackAxisSideDirection: "start",
                padding: 5,
            }),
            shift({ padding: 5 }),
        ],
    }), refs = _f.refs, floatingStyles = _f.floatingStyles, context = _f.context;
    var hover = useHover(context, {
        move: false,
        enabled: controlledOpen == null,
    });
    var focus = useFocus(context, {
        enabled: controlledOpen == null,
    });
    var dismiss = useDismiss(context);
    var role = useRole(context, { role: "tooltip" });
    var _g = useInteractions([role, hover, focus]), getReferenceProps = _g.getReferenceProps, getFloatingProps = _g.getFloatingProps, getItemProps = _g.getItemProps;
    return (_jsxs(_Fragment, { children: [React.isValidElement(children) &&
                React.cloneElement(children, getReferenceProps(__assign(__assign(__assign({ ref: refs.setReference }, props), children.props), { "data-state": context.open ? "open" : "closed" }))), open && !disabled && (_jsx(FloatingPortal, { children: _jsx(FloatingFocusManager, { context: context, modal: false, children: _jsx("div", __assign({ ref: refs.setFloating, className: "bg-[#4E4E4E] flex z-30 justify-center shadow-[0_3px_8px_rgba(0,0,0,0.24)] rounded-md  px-2 py-1  w-max text-white text-xs flex", role: "tooltip", "aria-orientation": "vertical", "aria-labelledby": "menu-button", tabIndex: "-1", style: __assign(__assign({}, floatingStyles), { background: "#4E4E4E", zIndex: 30 }) }, getFloatingProps(), { children: content })) }) }))] }));
};
export default Tooltip;
